export default __webpack_public_path__ + "static/char-v-54-ja-cb8c00a09c8197915e6b18a7b1aaef14.mp4";